module.exports = __webpack_public_path__ + "static/media/FifteenMinuteRule.4afad32c.png";